import {
  userLogin,
  getUserManage
} from "../../api/api.js"
import {
  getTokenInfo,
  setTokenInfo,
  removeTokenInfo,
  getExpire,
  setExpire,
  removeExpire
} from '../../utils/auth'
import {
  hex_md5
} from '@/utils/md5.js'
import enc from "@/utils/enc"
import Cookies from 'js-cookie'
import router from '../../router'
import MenuUtils from "../../utils/menuUtils.js"
import asyncMenu from "../../router/asyncMenu.js"
import menulistjson from "../../data/menulistjson.js"
import avatar from "@/assets/images/avatar2.jpg"
import { isLocal } from "@/settings.js"

const enc_b = new enc.Base64()
const _tokeninfo = getTokenInfo()
const _expire = getExpire()
const getDefaultState = () => {
  return {
    token: '', // !_tokeninfo ? '' : _tokeninfo.token,
    tokeninfo: '',// _tokeninfo,
    tokenExpires: 0,// !_expire ? 86400 : _expire,
    hospitalName: '',
    hospitalId: '',
    avatar: avatar,
    roleLimit: [0, 1, 2]
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_TOKENINFO: (state, info) => {
    state.tokenInfo = info
    state.token = info.token
    state.hospitalName = info.hospital_name
    state.hospitalId = info.hid
    state.tokenExpires = info.expires
  },
  SET_TOKENEXPIRES: (state, expires) => {
    state.tokenExpires = expires
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  }
}

const actions = {
  // 用户登录
  login({
    dispatch
  }, secret_key) {
    if (isLocal) {
      return new Promise(async (resolve, reject) => {
        await dispatch('loginLocal')
        resolve()
      })
    } else {
      // const secretkey = hex_md5(secret_key).toUpperCase()
      const secretkey = enc_b.encode(secret_key)
      return new Promise((resolve, reject) => {
        userLogin({
          query: {
            action: 'LoginBySecretKey'
          },
          body: {
            secret_key: secretkey
          }
        }).then(async response => {
          if (response.status == 0) {
            const {
              data
            } = response
            await dispatch('tokenInfo', JSON.stringify(data))
            resolve()
          } else {
            await dispatch('logout')
            reject()
          }
        }).catch(async error => {
          await dispatch('logout')
          reject(error)
        })
      })
    }
  },
  // 设置保存token信息
  tokenInfo({ commit, dispatch }, info) {
    return new Promise(async resolve => {
      const _info = JSON.parse(info)
      Cookies.remove('WOS-VERIFYLIMIT')
      setTokenInfo(info)
      commit('SET_TOKENINFO', _info)
      // commit('SET_TOKEN', _info.token)
      resolve()
    })
  },
  // 退出登录
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      removeTokenInfo() // 移除token信息
      removeExpire()
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/modules/workorder/store/modules/user.js